export const isAdjacentTeeth = (t1, t2) => {
    t1 = parseInt(t1);
    t2 = parseInt(t2);
    if (t1<30 && t2>30 || t1>30 && t2<30) return false;
    return (Math.abs(parseInt(t1)-parseInt(t2))===1 || (t1 % 10 === 1 && t2 % 10 === 1));
}

export const sortToothNumbers = (selection, method) => {
    if (typeof (selection)==="undefined") return null;
    if (selection[0] == 0) return selection;

    const regions = {r1: [], r2: [], r3: [], r4: []};
    for (const i in selection) {
        const r = "r"+Math.floor(selection[i]/10);
        if (!regions.hasOwnProperty(r)) continue;
        regions[r].push(selection[i]);
    }

    switch (method) {
        case "frontToBack":
            regions.r1.sort();
            regions.r2.sort();
            regions.r3.sort();
            regions.r4.sort();
            break;
        case "round":
        default:
            regions.r1.sort().reverse();
            regions.r2.sort();
            regions.r3.sort().reverse();
            regions.r4.sort();
            break;
    }

    selection = regions.r1.concat(regions.r2, regions.r3, regions.r4);

    const uniqueSelection = selection.filter(function(item, pos) {
        return selection.indexOf(item) == pos;
    });

    return uniqueSelection;
}
